import React, { useState, useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import Response_Processing from "../../../../src/layout/Others/Response_Processing";
import "./SocialLoginSettings.css";
import AdminSaveHeader from "../../../components/CommonComponents/AdminSaveHeader";
import FormContainer from "../../../components/CommonComponents/FormContainer";
import LeftWrapper from "../../../components/CommonComponents/LeftWrapper";
import Wrapper from "../../../components/CommonComponents/Wrapper";
import MessageHeading from "../../../components/CommonComponents/MessageHeading";
import MessageLabel from "../../../components/CommonComponents/MessageLabel";
import AdminSwitch from "../../../components/CommonComponents/AdminSwitch";
import AdminCustomInput from "../../../components/CommonComponents/AdminCustomInput";
import RightWrapper from "../../../components/CommonComponents/RightWrapper";
import AdminCustomButton from "../../../components/CommonComponents/AdminCustomButton";

function SocialLoginSettings(props) {
  const navigate = useNavigate();

  // Generate static callback URLs based on environment
  const WEBSITE_URL = process.env.REACT_APP_Baseurl_Frontend;
  const CALLBACK_URLS = {
    facebook: `${WEBSITE_URL}/auth/facebook/callback`,
    google: `${WEBSITE_URL}/auth/google/callback`,
    apple: `${WEBSITE_URL}/auth/apple/callback`
  };

  const [editUser, setEditUser] = useState({
    id: "",
    facebook: "",
    facebook_client_id: "",
    facebook_secrete_key: "",
    facebook_callback: CALLBACK_URLS.facebook,
    google: "",
    google_client_id: "",
    google_secrete_key: "",
    firebase_client_id: "",
    firebase_secrete_key: "",
    google_callback: CALLBACK_URLS.google,
    apple: "",
    apple_client_id: "",
    apple_callback: CALLBACK_URLS.apple,
    social_login_enabled: "",
    auto_register: 1,
    sync_profile_data: 1
  });
  const [message, setMessage] = useState("");
  const [errors, setErrors] = useState({});
  const access_token = localStorage.getItem("access_token");

  // console.log(access_token)

  const headers = {
    "Content-Type": "application/json",
    Authorization: "Bearer " + access_token,
    Accept: "application/json",
    "Access-Control-Allow-Origin": "*",
  };
  useEffect(async () => {
    const getUser = async () => {
      const reqData = await fetch(
        `${process.env.REACT_APP_Baseurl}/admin/social_setting`,
        { headers: headers }
      );
      const resData = await reqData?.json();
      var res = resData?.social_setting;

      // Override callback URLs with static values
      if (res) {
        res.facebook_callback = CALLBACK_URLS.facebook;
        res.google_callback = CALLBACK_URLS.google;
        res.apple_callback = CALLBACK_URLS.apple;
      }

      setEditUser(res);
      // console.log(resData)
      // console.log(res)
    };
    getUser();
  }, []);

  const handleInput = (e) => {
    const { name, value } = e.target;

    // Prevent changes to callback URLs as they are static
    if (name === 'facebook_callback' || name === 'google_callback' || name === 'apple_callback') {
      console.log(`Callback URL changes are not allowed. ${name} is automatically generated.`);
      return; // Don't update state for callback URLs
    }

    setEditUser(prev => ({ ...prev, [name]: value }));
  };
  const handleInputenable = (e, id) => {
    const { name, checked } = e.target;
    console.log(`Toggle changed: ${name} = ${checked ? 1 : 0}`);

    setEditUser(prev => ({
      ...prev,
      [name]: checked ? 1 : 0
    }));
  };

  const [processing, setProcessing] = useState(false);
  const [showOverlay, setShowOverlay] = useState(false);

  // Copy to clipboard functionality
  const copyToClipboard = async (text, provider) => {
    try {
      await navigator.clipboard.writeText(text);
      // You could show a toast notification here if available
      console.log(`${provider} callback URL copied to clipboard:`, text);
      // Temporary visual feedback (optional)
      const button = document.querySelector(`#copy-${provider}-btn`);
      if (button) {
        const originalText = button.innerHTML;
        button.innerHTML = '✓ Copied!';
        button.classList.add('text-success');
        setTimeout(() => {
          button.innerHTML = originalText;
          button.classList.remove('text-success');
        }, 2000);
      }
    } catch (err) {
      console.error('Failed to copy callback URL:', err);
    }
  };

  const handleUpdate = async (e) => {
    e.preventDefault();

    // No need to validate callback URLs since they're auto-generated and static
    setErrors({}); // Clear any previous errors

    const facebook = Number.isNaN(parseInt(editUser?.facebook, 10)) ? 0 : parseInt(editUser?.facebook, 10);
    const google = Number.isNaN(parseInt(editUser?.google, 10)) ? 0 : parseInt(editUser?.google, 10);

    // Ensure static callback URLs are always used
    const editInputvalue = {
      id: editUser?.id,
      facebook: facebook,
      facebook_client_id: editUser?.facebook_client_id,
      facebook_secrete_key: editUser?.facebook_secrete_key,
      facebook_callback: CALLBACK_URLS.facebook, // Always use static URL
      google: google,
      google_client_id: editUser?.google_client_id,
      google_secrete_key: editUser?.google_secrete_key,
      firebase_client_id: editUser?.firebase_client_id,
      firebase_secrete_key: editUser?.firebase_secrete_key,
      google_callback: CALLBACK_URLS.google, // Always use static URL
      apple: Number.isNaN(parseInt(editUser?.apple, 10)) ? 0 : parseInt(editUser?.apple, 10),
      apple_client_id: editUser?.apple_client_id,
      apple_callback: CALLBACK_URLS.apple, // Always use static URL
      social_login_enabled: Number.isNaN(parseInt(editUser?.social_login_enabled, 10)) ? 0 : parseInt(editUser?.social_login_enabled, 10),
      auto_register: Number.isNaN(parseInt(editUser?.auto_register, 10)) ? 1 : parseInt(editUser?.auto_register, 10),
      sync_profile_data: Number.isNaN(parseInt(editUser?.sync_profile_data, 10)) ? 1 : parseInt(editUser?.sync_profile_data, 10)
    };

    console.log('Sending social login settings update:', editInputvalue);

    let firstApiStatus = false;
    let resultapi = null;
    let resjson = null;
    setProcessing(true);
    setShowOverlay(true);

    try {
      const res = await fetch(
        `${process.env.REACT_APP_Baseurl}/admin/social_setting_store`,
        {
          method: "POST",
          headers: headers,
          body: JSON.stringify(editInputvalue),
        }
      );

      resjson = await res.json();
      console.log('Social login settings response:', resjson);

      if (resjson.status === true) {
        firstApiStatus = true;
        resultapi = resjson;
      }
    } catch (error) {
      console.error("Social login settings update error:", error);
    }

    if (firstApiStatus) {
      console.log('Social login settings updated successfully');
      props.setApiresponsealert(resultapi);
      props.setShowalert(true);
      setTimeout(() => {
        window.location.reload();
      }, 3000);
    } else {
      console.error('Social login settings update failed:', resjson);
      if (resjson && resjson.status === false) {
        var resultError = resjson;
        props.setApiresponsealert(resultError);
        props.setShowalert(true);
        setProcessing(false);
        setShowOverlay(false);
      } else {
        // Fallback error handling
        const fallbackError = {
          status: false,
          message: 'Update failed. Please check your connection and try again.'
        };
        props.setApiresponsealert(fallbackError);
        props.setShowalert(true);
        setProcessing(false);
        setShowOverlay(false);
      }
    }
  };

  // const handleUpdate = async (e) => {
  //   e.preventDefault();
  //   const editInputvalue = {
  //     id: editUser?.id,
  //     facebook: editUser?.facebook,
  //     facebook_client_id: editUser?.facebook_client_id,
  //     facebook_secrete_key: editUser?.facebook_secrete_key,
  //     facebook_callback: editUser?.facebook_callback,
  //     google: editUser?.google,
  //     google_client_id: editUser?.google_client_id,
  //     google_secrete_key: editUser?.google_secrete_key,
  //     google_callback: editUser?.google_callback,
  //   };
  //   // console.log(editInputvalue);
  //   let res = await fetch(
  //     `${process.env.REACT_APP_Baseurl}/admin/social_setting_store`,
  //     {
  //       method: "POST",
  //       headers: headers,
  //       body: JSON.stringify(editInputvalue),
  //     }
  //   );

  //   let resjson = await res.json();
  //   // console.log(resjson)
  //   if (res.status === 200) {
  //     setMessage(resjson.success);
  //     alert("Success");
  //     setTimeout(() => {
  //       window.location.reload();
  //     }, 2000);
  //   } else {
  //     setMessage("Some error Occured");
  //     console.log("Error");
  //     alert("Enter Correct Details");
  //   }
  // };

  const facebook = () => {
    window.open(
      "https://developers.facebook.com/docs/development/create-an-app",
      "_blank"
    );
  };
  const google = () => {
    window.open(
      "https://developers.google.com/identity/sign-in/web/sign-in",
      "_blank"
    );
  };

  return (
    <>

      {showOverlay && (<Response_Processing />)}
      <AdminSaveHeader heading={"Social Login Settings"} saveText={"Update Settings"} saveMethod={handleUpdate} />

      {/* Global Social Login Toggle */}
      <FormContainer>
        <LeftWrapper>
          <Wrapper>
            <h5>Social Login Configuration</h5>
            <hr></hr>
            <div className="d-flex justify-content-between mb-3 ">
              <div className="col-8 col-md-8 pe-2">
                <MessageLabel text={"Enable Social Login Globally"} />
                <small className="text-muted d-block">Turn this off to disable all social login providers</small>
              </div>
              <div className="col-4 col-md-4 ps-2 text-end">
                <AdminSwitch id="social_login_enabled" name={'social_login_enabled'} checked={editUser?.social_login_enabled == 1} onChange={handleInputenable} />
              </div>
            </div>
            <div className="d-flex justify-content-between mb-3 ">
              <div className="col-8 col-md-8 pe-2">
                <MessageLabel text={"Auto Register New Users"} />
                <small className="text-muted d-block">Automatically create accounts for new social login users</small>
              </div>
              <div className="col-4 col-md-4 ps-2 text-end">
                <AdminSwitch id="auto_register" name={'auto_register'} checked={editUser?.auto_register == 1} onChange={handleInputenable} />
              </div>
            </div>
            <div className="d-flex justify-content-between mb-3 ">
              <div className="col-8 col-md-8 pe-2">
                <MessageLabel text={"Sync Profile Data"} />
                <small className="text-muted d-block">Update user profile with latest social media data</small>
              </div>
              <div className="col-4 col-md-4 ps-2 text-end">
                <AdminSwitch id="sync_profile_data" name={'sync_profile_data'} checked={editUser?.sync_profile_data == 1} onChange={handleInputenable} />
              </div>
            </div>
          </Wrapper>
        </LeftWrapper>
      </FormContainer>

      <FormContainer>
        <LeftWrapper>
          <Wrapper>
            <h5>Facebook Login Details</h5>
            <small>
              To Create Facebook{" "}
              <span className="fs-6 fglogin" onClick={facebook}>
                Click Here
              </span>
              .
            </small>
            <hr></hr>
            <div className="d-flex justify-content-between mb-2 ">
              <div className="col-6 col-md-6 pe-2">
                <MessageLabel text={"Enable Facebook"} />
              </div>
              <div className="col-6 col-md-6 ps-2 text-end">
                <AdminSwitch id="facebook" name={'facebook'} checked={editUser?.facebook == 1} onChange={handleInputenable} />
              </div>
            </div>
            <MessageLabel text={"Client ID"} />
            <AdminCustomInput type="text" id="facebook_client_id" placeHolder={"Enter facebook client id"} name="facebook_client_id" value={editUser?.facebook_client_id} onChange={handleInput} />
            <MessageLabel text={"Secrete Key"} />
            <AdminCustomInput type="text" id="facebook_secrete_key" placeHolder={"Enter facebook secred key"} name="facebook_secrete_key" value={editUser?.facebook_secrete_key} onChange={handleInput} />
            <MessageLabel text={"Call Back URL"} />
            <div className="position-relative mb-3">
              <div className="d-flex align-items-center">
                <input
                  type="text"
                  className="custom-input custom-input-border w-100 custom-placeholder bg-light theme-text-color mb-0"
                  value={CALLBACK_URLS.facebook}
                  readOnly
                  style={{ cursor: 'default' }}
                />
                <button
                  type="button"
                  className="btn btn-sm btn-outline-secondary ms-2"
                  id="copy-facebook-btn"
                  onClick={() => copyToClipboard(CALLBACK_URLS.facebook, 'facebook')}
                  title="Copy callback URL"
                >
                  📋 Copy
                </button>
              </div>
              <small className="text-muted mt-1 d-block">
                🔒 This callback URL is automatically generated and cannot be changed. Use this URL in your Facebook App settings.
              </small>
            </div>
          </Wrapper>
        </LeftWrapper>
        <RightWrapper>
          <Wrapper>
            <h5>Google Login Details</h5>
            <small>
              To Create Google{" "}
              <span className="fs-6 fglogin" onClick={google}>
                Click Here
              </span>
              .
            </small>
            <hr></hr>
            <div className="d-flex justify-content-between mb-2 ">
              <div className="col-6 col-md-6 pe-2">
                <MessageLabel text={"Enable Google"} />
              </div>
              <div className="col-6 col-md-6 ps-2 text-end">
                <AdminSwitch id="google" name={'google'} checked={editUser?.google == 1} onChange={handleInputenable} />
              </div>
            </div>
            <MessageLabel text={"Client ID"} />
            <AdminCustomInput type="text" id="google_client_id" placeHolder={"Enter google client id"} name="google_client_id" value={editUser?.google_client_id} onChange={handleInput} />
            <MessageLabel text={"Secrete Key"} />
            <AdminCustomInput type="text" id="google_secrete_key" placeHolder={"Enter google secret key"} name="google_secrete_key" value={editUser?.google_secrete_key} onChange={handleInput} />
            <MessageLabel text={"Firebase Client ID"} />
            <AdminCustomInput type="text" id="firebase_client_id" placeHolder={"Enter firebase client id"} name="firebase_client_id" value={editUser?.firebase_client_id} onChange={handleInput} />
            <MessageLabel text={"Firebase Secrete Key"} />
            <AdminCustomInput type="text" id="firebase_secrete_key" placeHolder={"Enter firebase secret key"} name="firebase_secrete_key" value={editUser?.firebase_secrete_key} onChange={handleInput} />
            <MessageLabel text={"Call Back URL"} />
            <div className="position-relative mb-3">
              <div className="d-flex align-items-center">
                <input
                  type="text"
                  className="custom-input custom-input-border w-100 custom-placeholder bg-light theme-text-color mb-0"
                  value={CALLBACK_URLS.google}
                  readOnly
                  style={{ cursor: 'default' }}
                />
                <button
                  type="button"
                  className="btn btn-sm btn-outline-secondary ms-2"
                  id="copy-google-btn"
                  onClick={() => copyToClipboard(CALLBACK_URLS.google, 'google')}
                  title="Copy callback URL"
                >
                  📋 Copy
                </button>
              </div>
              <small className="text-muted mt-1 d-block">
                🔒 This callback URL is automatically generated and cannot be changed. Use this URL in your Google OAuth settings.
              </small>
            </div>
          </Wrapper>
        </RightWrapper>
      </FormContainer>

      {/* Apple Login Section */}
      <FormContainer>
        <LeftWrapper>
          <Wrapper>
            <h5>Apple Login Details</h5>
            <small>
              To Create Apple Sign In{" "}
              <span className="fs-6 fglogin" onClick={() => window.open('https://developer.apple.com/sign-in-with-apple/', '_blank')}>
                Click Here
              </span>
              .
            </small>
            <hr></hr>
            <div className="d-flex justify-content-between mb-2 ">
              <div className="col-6 col-md-6 pe-2">
                <MessageLabel text={"Enable Apple"} />
              </div>
              <div className="col-6 col-md-6 ps-2 text-end">
                <AdminSwitch id="apple" name={'apple'} checked={editUser?.apple == 1} onChange={handleInputenable} />
              </div>
            </div>
            <MessageLabel text={"Client ID (Service ID)"} />
            <AdminCustomInput type="text" id="apple_client_id" placeHolder={"Enter apple client id"} name="apple_client_id" value={editUser?.apple_client_id} onChange={handleInput} />
            <MessageLabel text={"Callback URL"} />
            <div className="position-relative mb-3">
              <div className="d-flex align-items-center">
                <input
                  type="text"
                  className="custom-input custom-input-border w-100 custom-placeholder bg-light theme-text-color mb-0"
                  value={CALLBACK_URLS.apple}
                  readOnly
                  style={{ cursor: 'default' }}
                />
                <button
                  type="button"
                  className="btn btn-sm btn-outline-secondary ms-2"
                  id="copy-apple-btn"
                  onClick={() => copyToClipboard(CALLBACK_URLS.apple, 'apple')}
                  title="Copy callback URL"
                >
                  📋 Copy
                </button>
              </div>
              <small className="text-muted mt-1 d-block">
                🔒 This callback URL is automatically generated and cannot be changed. Use this URL in your Apple Sign In configuration.
              </small>
            </div>
          </Wrapper>
        </LeftWrapper>
      </FormContainer>

      <FormContainer>
        <AdminCustomButton saveMethod={handleUpdate} type="submit" saveText={"Update Settings"} className="ms-auto" loading={showOverlay} />
      </FormContainer>

      {/* <div className=" m-0 p-0">
        <div className="">
          <section className="section dashboard pt-2">
            <div className="container-fluid  p-3">
              <div className="iq-card">
                <div id="admin-container">
                  <div className="admin-section-title">
                    <h4>
                      <i className="entypo-credit-card"></i> Social Login
                      Settings
                    </h4>
                  </div>

                  <form>
                    <div className="row">
                      <div className="col-md-6">
                        <div
                          className="panel panel-primary mt-3"
                          data-collapsed="0"
                        >
                          <div className="panel-heading">
                            <h6 className="panel-title">
                              Facebook Login Details{" "}
                            </h6>
                            <div className="panel-options">
                              <small>
                                To Create Facebook{" "}
                                <span
                                  className="fs-6 fglogin"
                                  onClick={facebook}
                                >
                                  Click Here
                                </span>
                                .
                              </small>
                            </div>
                            <hr />
                          </div>
                          <div className="panel-body">
                            <div className="row">
                              <p className="col-md-6">
                                <label>Enable Facebook:</label>
                              </p>
                              <div className=" col-md-6 d-flex justify-content-around align-items-center">
                                <div>
                                  <label>ON</label>
                                </div>
                                <div>
                                  <label className="switch">
                                    <input
                                      name="facebook"
                                      onChange={handleInput}
                                      defaultChecked={
                                        editUser?.facebook === 1 ? true : false
                                      }
                                      checked={
                                        editUser?.facebook === 1 ? true : false
                                      }
                                      type="checkbox"
                                    />
                                    <span
                                      className="slider round"
                                      name="facebook"
                                      onChange={handleInput}
                                      value={
                                        editUser?.facebook === 1 ? "1" : "0"
                                      }
                                    ></span>
                                  </label>
                                </div>
                                <div>
                                  <label>OFF</label>
                                </div>
                              </div>
                            </div>

                            <label>Client ID:</label>
                            <input
                              type="text"
                              className="form-control"
                              name="facebook_client_id"
                              id="facebook_client_id"
                              placeholder="Client ID"
                              onChange={handleInput}
                              value={editUser?.facebook_client_id}
                            />

                            <br />
                            <label>Secrete Key:</label>
                            <input
                              type="text"
                              className="form-control"
                              name="facebook_secrete_key"
                              id="facebook_secrete_key"
                              placeholder="Secrete Key"
                              onChange={handleInput}
                              value={editUser?.facebook_secrete_key}
                            />

                            <br />
                            <label>Call Back URL:</label>
                            <input
                              type="text"
                              className="form-control"
                              name="facebook_callback"
                              id="facebook_callback"
                              placeholder="Call Back URL"
                              onChange={handleInput}
                              value={editUser?.facebook_callback}
                            />
                          </div>
                        </div>
                      </div>
                      <div className="col-md-6 mt-3">
                        <div className="panel panel-primary" data-collapsed="0">
                          <div className="panel-heading">
                            <h6 className="panel-title">
                              Google Login Details{" "}
                            </h6>
                            <div className="panel-options">
                              <small>
                                To Create Google{" "}
                                <span
                                  className="fs-6  fglogin"
                                  onClick={google}
                                >
                                  Click Here
                                </span>
                                .
                              </small>
                            </div>
                            <hr />
                          </div>
                          <div className="panel-body">
                            <div className="row">
                              <p className="col-md-6">
                                <label>Enable Google:</label>
                              </p>
                              <div className="col-md-6 d-flex justify-content-around align-items-center">
                                <div>
                                  <label>ON</label>
                                </div>
                                <div>
                                  <label className="switch">
                                    <input
                                      name="google"
                                      onChange={handleInput}
                                      defaultChecked={
                                        editUser?.google === 1 ? true : false
                                      }
                                      checked={
                                        editUser?.google === 1 ? true : false
                                      }
                                      type="checkbox"
                                    />
                                    <span
                                      className="slider round"
                                      name="google"
                                      onChange={handleInput}
                                      value={editUser?.google === 1 ? "1" : "0"}
                                    ></span>
                                  </label>
                                </div>
                                <div>
                                  <label>OFF</label>
                                </div>
                              </div>
                            </div>

                            <label>Client ID:</label>
                            <input
                              type="text"
                              className="form-control"
                              name="google_client_id"
                              id="google_client_id"
                              placeholder="Client ID"
                              onChange={handleInput}
                              value={editUser?.google_client_id}
                            />

                            <br />
                            <label>Secrete Key:</label>
                            <input
                              type="text"
                              className="form-control"
                              name="google_secrete_key"
                              id="google_secrete_key"
                              placeholder="Secrete Key"
                              onChange={handleInput}
                              value={editUser?.google_secrete_key}
                            />

                            <br />
                            <label>Call Back URL:</label>
                            <input
                              type="text"
                              className="form-control"
                              name="google_callback"
                              id="google_callback"
                              placeholder="Call Back URL"
                              onChange={handleInput}
                              value={editUser?.google_callback}
                            />
                          </div>
                        </div>
                      </div>
                    </div>

                    <input type="hidden" name="_token" value="" />
                    <div className="panel-body mt-3 text-end p-3">
                      <input
                        type="submit"
                        value="Update Settings"
                        className="btn btn-primary "
                        onClick={handleUpdate}
                      />
                    </div>
                  </form>
                </div>
              </div>
            </div>
          </section>
        </div>
      </div> */}
    </>
  );
}

export default SocialLoginSettings;
